// extracted by mini-css-extract-plugin
export default {"Map":"Map_Map__en8UV"};